import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    redirect: '/home',
    meta: {
      title: "首页",
      keepAlive: true
    },
  },
  {
    path: "/home",
    name: "home",
    meta: {
      title: "首页",
    },
    component: () => import('../views/home.vue')
  },
  {
    path: "/news",
    name: "news",
    meta: {
      title: "新闻",
    },
    component: () => import('../views/news.vue')
  },
  {
    path: "/newsdetail",
    name: "newsdetail",
    meta: {
      title: "新闻详情",
    },
    component: () => import('../views/newsdetail.vue') },
    { path: "/productsdetail",
    name: "productsdetail",
    meta: {
      title: "产品详情",
    },
    component: () => import('../views/productsdetail.vue')
  },
  {
    path: "/solutiondetail",
    name: "solutiondetail",
    meta: {
      title: "方案详情",
    },
    component: () => import('../views/solutiondetail.vue')
  },
  {
    path: "/businessConsultation",
    name: "businessConsultation",
    meta: {
      title: "业务咨询",
    },
    component: () => import('../views/businessConsultation.vue')
  },
  {
    path: "/aboutus",
    name: "aboutus",
    meta: {
      title: "关于我们",
    },
    component: () => import('../views/aboutus.vue')
  },
  {
    path: '/search',
    name: 'search',
    meta: {
      title: '搜索结果'
    },
    component: () => import('../views/search.vue')
  },
  {
    path: "/store",
    name: "store",
    meta: {
      title: "应用商店",
    },
    component: () => import('../views/store/index.vue')
  },
  {
    path: "/searchlist",
    name: "searchlist",
    meta: {
      title: "商品列表",
    },
    component: () => import('../views/store/storeList/index.vue')
  },
  {
    path: "/detail",
    name: "detail",
    meta: {
      title: "商品详情",
    },
    component: () => import('../views/store/storeDetail')
  },
   {
    path: "/develop",
    name: "develop",
    meta: {
      title: "社区",
    },
    component: () => import('../views/community/CommunityPage.vue')
  }, {
    path: "/articldetail",
    name: "articldetail",
    meta: {
      title: "社区详情",
    },
    component: () => import('../views/community/details/CommunitydetailsPage.vue')
  },
  {
    path: "/quedetail",
    name: "quedetail",
    meta: {
      title: "社区详情",
    },
    component: () => import('../views/community/details/quedetail.vue')
  },
  {
    path: "/componentLibrary",
    name: "componentLibrary",
    meta: {
      title: "工业微服务组件库",
    },
    component: () => import('../views/componentLibrary/index.vue')
  },
  {
    path: "/componentDetail",
    name: "componentDetail",
    meta: {
      title: "工业微服务组件库详情",
    },
    component: () => import('../views/componentLibrary/detail.vue')
  }
];

const  scrollBehavior = () => {
  return { x: 0, y:0 };
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior
});

router.beforeEach((to, from, next) => {
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title + "-硅基半导体材料工业互联网平台";
  }
  next();
});

export default router;
